import React from "react";
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import ToastContainer from "react-bootstrap/ToastContainer";
import Toast from "react-bootstrap/Toast";
import ToastHeader from "react-bootstrap/ToastHeader";
import ToastBody from "react-bootstrap/ToastBody";
import Spinner from "react-bootstrap/Spinner";
import Pagination from "react-bootstrap/Pagination";
import FormSelect from "react-bootstrap/FormSelect";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ProgressBar from "react-bootstrap/ProgressBar";

export const SchoolEnrollments = (props) => {
  return (
    <Container fluid={true} className="position-relative">
      <ToastContainer position="top-end" className="pt-2 pe-md-1">
        <Toast show={props.loading} bg="info">
          <ToastBody>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />{" "}
            Getting all enrollments
          </ToastBody>
        </Toast>
        <Toast
          show={props.error !== null}
          bg="danger"
          onClose={props.dismissError}
        >
          <ToastHeader closeButton={true}>
            <strong className="me-auto">Fetch error</strong>
          </ToastHeader>
          <ToastBody>{props.error}</ToastBody>
        </Toast>
      </ToastContainer>
      <Row className="g-2">
        <Col className="col-auto">
          <Pagination>
            {props.renderPageItems(props.page, props.total, props.changePage)}
          </Pagination>
        </Col>
        <Col className="col-auto">
          <FormSelect value={props.size} onChange={props.changeSize}>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={200}>200</option>
          </FormSelect>
        </Col>
      </Row>
      <Table hover={true} striped={true} bordered={true} responsive="sm">
        <thead>
          <tr>
            <th>School</th>
            <th>Learner name</th>
            <th>Parent email ID</th>
            <th>Program</th>
            <th>Progress</th>
            <th>Completed on</th>
            <th>Expires on</th>
            <th>Surveyed on</th>
          </tr>
        </thead>
        <tbody>
          {props.enrollments.map((e, index) => (
            <tr key={index}>
              <td>{e.school?.name}</td>
              <td>{e.learner?.first_name + " " + e.learner?.last_name}</td>
              <td>{e.learner?.parent?.email_id}</td>
              <td>{e.program?.name}</td>
              <td>
                <ProgressBar
                  now={props.getProgress(
                    e?.current_level,
                    e?.program?.level_sequence?.length
                  )}
                />
              </td>
              <td>{props.formatDate(e?.completed_on, "Not done yet")}</td>
              <td>{props.formatDate(e?.expires_at, "Not completed yet", true)}</td>
              <td>{props.formatDate(e?.surveyed_on, "Not completed yet")}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Row className="g-2">
        <Col className="col-auto">
          <Pagination>
            {props.renderPageItems(props.page, props.total, props.changePage)}
          </Pagination>
        </Col>
        <Col className="col-auto">
          <FormSelect value={props.size} onChange={props.changeSize}>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={200}>200</option>
          </FormSelect>
        </Col>
      </Row>
    </Container>
  );
};
